import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Section,
  SectionTitle,
  Card,
  FormSection,
  SectionHeader,
  FieldGroup,
  Field,
  Label,
  Input,
  Error,
  Actions,
  PrimaryButton,
  FormError,
  FieldHelper
} from "../styles/StyledComponents";

/* -------------------- Mounted Guard Hook -------------------- */
function useIsMounted() {
  const ref = React.useRef(false);
  useEffect(() => {
    ref.current = true;
    return () => { ref.current = false; };
  }, []);
  return ref;
}

const TrackTransport = () => {
  const [nId, setnId] = useState("");
  const [nIderror, setnIderror] = useState("");
  const [parentId, setParentId] = useState("");
  const [parentError, setParentError] = useState("");
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const isMounted = useIsMounted();

  // ✅ Saudi ID Validator
  const isSaudiIdValid = (idNumber) => {
    idNumber = idNumber.replace(/\D/g, ""); // keep digits only
    if (idNumber.length !== 10) return false;

    let sum = 0;
    let shouldDouble = true;
    for (let i = idNumber.length - 2; i >= 0; i--) {
      let digit = parseInt(idNumber.charAt(i));
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }
    const checkDigit = (10 - (sum % 10)) % 10;
    return checkDigit === parseInt(idNumber.charAt(9));
  };

  const handleSubmit = () => {
    setStatus("");

    if (!nId || !isSaudiIdValid(nId)) {
      setnIderror("يرجى إدخال رقم هوية الطالب بشكل صحيح ");
      return;
    }

    if (!parentId || !isSaudiIdValid(parentId)) {
      setParentError("يرجى إدخال رقم هوية ولي الأمر بشكل صحيح ");
      return;
    }

    setnIderror("");
    setParentError("");
    setError("");
    setIsLoading(true);

    const controller = new AbortController();
    let url = `https://reports-api.tatweertransit.com/cs/api/getRequestStatus?nId=${encodeURIComponent(
      nId
    )}&parentId=${encodeURIComponent(parentId)}`;

    axios(url, { signal: controller.signal })
      .then((res) => {
        if (!isMounted.current) return;
        setStatus(res?.data?.Data ?? "");
      })
      .catch(() => {
        if (!isMounted.current) return;
        setStatus("لم يتم العثور على بيانات");
      })
      .finally(() => {
        if (!isMounted.current) return;
        setIsLoading(false);
      });
  };

  return (
    <Section>
      <SectionTitle>متابعة حالة طلب النقل المدرسي</SectionTitle>
      <Card>
        <FormSection>
          <SectionHeader>بيانات التحقق</SectionHeader>
          <FieldGroup>
            <Field>
              <Label htmlFor="nId" className="required">رقم هوية الطالب</Label>
              <Input
                id="nId"
                type="text"
                inputMode="numeric"
                value={nId}
                placeholder="أدخل رقم هوية الطالب (10 أرقام)"
                aria-invalid={!!nIderror}
                onChange={(e) => setnId(e.target.value.slice(0, 10))}
              />
              <FieldHelper>رقم الهوية المكون من 10 أرقام</FieldHelper>
              {nIderror && <Error>{nIderror}</Error>}
            </Field>

            <Field>
              <Label htmlFor="parentId" className="required">رقم هوية ولي الأمر</Label>
              <Input
                id="parentId"
                type="text"
                inputMode="numeric"
                value={parentId}
                placeholder="أدخل رقم هوية ولي الأمر (10 أرقام)"
                aria-invalid={!!parentError}
                onChange={(e) => setParentId(e.target.value.slice(0, 10))}
              />
              <FieldHelper>مطلوب للتحقق من الهوية</FieldHelper>
              {parentError && <Error>{parentError}</Error>}
            </Field>
          </FieldGroup>

          {error && <FormError>{error}</FormError>}

          <Actions>
            <PrimaryButton
              type="button"
              onClick={handleSubmit}
              disabled={isLoading || !nId || !parentId}
              aria-busy={isLoading}
            >
              {isLoading ? "جاري البحث..." : "استعلام الحالة"}
            </PrimaryButton>
          </Actions>

          {status !== "" && !isLoading && (
            <FormSection style={{ marginTop: '24px', background: '#f8fafc' }}>
              <SectionHeader>حالة الطلب</SectionHeader>
              <Field>
                <Label>الحالة الحالية</Label>
                <Input 
                  id="status" 
                  type="text" 
                  value={status} 
                  readOnly 
                  style={{ 
                    background: '#e2e8f0', 
                    fontWeight: 'bold',
                    color: 'var(--brand)'
                  }} 
                />
              </Field>
            </FormSection>
          )}
        </FormSection>
      </Card>
    </Section>
  );
};

export default TrackTransport;
